<ng-container>
  <div class="app-initializing">
    <h1>{{ 'systemReady.systemInitializing' | translate }}</h1>
    <div class="app-content">
      <frodo-logo
        class="main-logo"
        [src]="'../../assets/logo-icon.svg'"
        [alt]="'logo'"
      ></frodo-logo>
      <h2>{{ 'systemReady.gettingSystemReady' | translate }}</h2>
    </div>
    <frodo-logo class="apex-logo" [src]="'../../assets/logo.png'" [alt]="'logo'"></frodo-logo>
  </div>
</ng-container>
